document.addEventListener('DOMContentLoaded', () => {
	syncWishlistCount();
	initGpoSubmitSync();
});

function syncWishlistCount() {
	const BADGE_SELECTOR = '.MuiBadge-badge.MuiBadge-anchorOriginTopLeftRectangle.MuiBadge-colorSecondary';
	const CUSTOM_COUNT_SELECTOR = '.wishlist-count';

	let badgeNode = null;
	let badgeTextObserver = null;

	const extractCount = (node) => {
		const numeric = (node?.textContent || '').replace(/[^\d]/g, '');
		const parsed = parseInt(numeric, 10);
		return Number.isFinite(parsed) ? parsed : 0;
	};

	const updateCustomCount = (count) => {
		document.querySelectorAll(CUSTOM_COUNT_SELECTOR).forEach((el) => {
			el.textContent = count;
			el.classList.toggle('hidden', count <= 0);
		});
	};

	const watchBadgeText = (node) => {
		if (!node || node === badgeNode) return;

		badgeNode = node;
		if (badgeTextObserver) badgeTextObserver.disconnect();

		const sync = () => updateCustomCount(extractCount(node));
		sync();

		badgeTextObserver = new MutationObserver(sync);
		badgeTextObserver.observe(node, { childList: true, characterData: true, subtree: true });
	};

	const monitorForBadge = () => {
		const immediateBadge = document.querySelector(BADGE_SELECTOR);
		if (immediateBadge) watchBadgeText(immediateBadge);

		const bodyObserver = new MutationObserver(() => {
			const candidate = document.querySelector(BADGE_SELECTOR);
			if (candidate && candidate !== badgeNode) {
				watchBadgeText(candidate);
			}
		});

		bodyObserver.observe(document.body, { childList: true, subtree: true });
	};

	monitorForBadge();
}

function initGpoSubmitSync() {
	const SUBMIT_SELECTOR = '.product-form__submit';

	const isGloboField = (el) => !!el?.closest('.gpo-option, .gpo-field, .globo-options');

	const enableIfValid = () => {
		const btn = document.querySelector(SUBMIT_SELECTOR);
		if (!btn) return;

		const hasInvalidRequired = !!document.querySelector('.gpo-field.gpo-required :invalid');
		if (!hasInvalidRequired) {
			btn.disabled = false;
			btn.classList.remove('disabled');
		}
	};

	document.addEventListener('change', (evt) => {
		if (!isGloboField(evt.target)) return;
		enableIfValid();
	});

	const form = document.querySelector('.product-form');
	if (form) {
		const observer = new MutationObserver(() => enableIfValid());
		observer.observe(form, { childList: true, subtree: true });
	}

	enableIfValid();
}